(function () {
  function initCard(card) {
    var img =
      card.querySelector('.card__media img') ||
      card.querySelector('.media img') ||
      card.querySelector('img');
    if (!img) return;
    var sws = card.querySelectorAll('.av-sw__item[data-image]');
    if (!sws.length) return;

    var orig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
    var timer;

    function swap(url) {
      img.style.transition = 'opacity .16s ease';
      img.style.opacity = '0';
      clearTimeout(timer);
      timer = setTimeout(function () {
        img.removeAttribute('srcset');
        img.setAttribute('src', url);
        img.style.opacity = '1';
      }, 160);
    }
    function restore() {
      img.style.transition = 'opacity .16s ease';
      img.style.opacity = '0';
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (orig.srcset) { img.setAttribute('srcset', orig.srcset); }
        img.setAttribute('src', orig.src);
        img.style.opacity = '1';
      }, 160);
    }

    sws.forEach(function (a) {
      var url = a.getAttribute('data-image');
      if (!url) return;
      var pre;
      function enter() { if (!pre) { pre = new Image(); pre.src = url; } swap(url); }
      a.addEventListener('mouseenter', enter);
      a.addEventListener('focus', enter);
      a.addEventListener('mouseleave', restore);
      a.addEventListener('blur', restore);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(initCard);
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', function () { init(); }); }

  // re-init after theme editor section loads / AJAX collection updates
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:afterNavigation', function () { init(); });
})();
